module.exports = __webpack_public_path__ + "img/ic_tour.24738eb1.svg";